import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import congressSplash from './../../images/congress-splash.jpg'

const useStyles = makeStyles((theme) => ({
	container: {
		position: 'relative',
		textAlign: 'center',
		marginTop: 20,
		whiteSpace: 'nowrap',
		display: 'block'
	},
	image: {
		width: '100%',
		maxHeight: 400,
	},
	overlay: {
		position: 'absolute',
		top: '50%',
		left:'50%',
		width: '100%',
		height: '100%',
		backgroundColor: 'rgba(0,0,0,0.25)',
		transform: 'translate(-50%, -50%)'
	},
	titleText: {
		color: '#FFFFFF',
		fontFamily: 'Graphik',
		[theme.breakpoints.down('xs')]: {
      		fontSize: 22
    	},
    	[theme.breakpoints.up('sm')]: {
      		fontSize: 42
    	},
		fontWeight: 700,
		letterSpacing: 0,
		textAlign: 'center',
		position: 'absolute',
		top: '50%',
		left:'50%',
		width: '100%',
		transform: 'translate(-50%, -50%)'
	}
}));

const Splash = (props) => {
	const {
		splash = congressSplash,
		overlay = "Members of the 117th Congress"
	} = props;

	const classes = useStyles();

	return (
		<div className={classes.container}>
			<img src={splash} className={classes.image} alt="A mobile phone and laptop displaying screenshots from the FiscalNote platform" />
			<div className={classes.overlay}></div>
			<div className={classes.titleText}>{overlay}</div>
		</div>
	)
}

export default Splash;
